<template>
  <v-dialog width="640" v-bind="$attrs" v-on="$listeners">
    <div style="background-color: #fff; width: 100%; padding: 0px 10px 0 10px">
      <div class="pa-2" style="border-bottom: solid 1px #9e9e9e">
        {{ modal && modal.data && modal.data.title }}
      </div>

      <!-- <p class="pa-4 ma-0" dir="auto" style="height: 440px; overflow-y: scroll;"> {{ messageList }}</p> -->
      <div v-if="messageList.length > 0">
        <span class="pa-4 ma-0" dir="rtl" style="height: auto; overflow-y: scroll">
          <v-alert v-for="m in messageList" :key="messageList.indexOf(m)" text dense :type="errorType(m.level)" class="multi-line">
            <!-- Show Message Start -->
            <div class="show-message" v-html="m.message"></div>
            <!-- <span v-html="m.message"></span> -->
            <!-- Show Message End-->
          </v-alert>
        </span>
      </div>
      <div class="someshityclass" style="height: 440px; overflow-y: scroll"
        v-else-if="!newMessage && this.modal.data.content.$messages === undefined && this.modal.data.content.$exception && undefined">
        <p v-for="(item, index) in newMessage" class="pa-4 ma-0" dir="auto" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else>
        <p class="pa-4 ma-0" dir="auto" style="height: 440px; overflow-y: scroll">
          <span v-html="getHeaders"></span>
          {{ modal && modal.data && modal.data.content }}
        </p>
      </div>

    </div>

    <AppFooter>
      <v-btn @click="modal.modal.close()">
        بستن
      </v-btn>
      <div style="font-size: 15px;margin-right:5rem ">
        <span v-html="getTraceID"></span>
      </div>
      <!-- <v-btn class="mx-2" @click="modal.modal.close()">تایید</v-btn> -->
    </AppFooter>
  </v-dialog>
</template>

<script>
import AppFooter from "@/components/library/container/AppFooter";
import { fetchDefData } from "@/apis";

export default {
  name: "AppDialogMessageBox",
  components: { AppFooter },
  props: ["modal"],
  data: function () {
    return {
      messageList: [],
      newMessage: []
    };
  },
  computed: {
    getHeaders() {
      const headers = this.modal?.data?.headers;
      const sessionID = headers["x-abr-contextid"];
      const contextID = headers["x-abr-sessionid"];
      const traceID = headers["x-abr-traceid"];
      console.log(traceID, "traceID")
      if (!contextID && !sessionID && !traceID) return "";
      return `<div>Session ID: ${sessionID}</div><div>Context ID: ${contextID}</div>`;
    },
    getTraceID() {
      const headers = this.modal?.data?.headers;
      const traceID = headers["x-abr-traceid"];
      return `<div style="direction :ltr;background-color : none";font-size :5px; >TraceID : ${traceID}</div>`
    }
  },
  async created() {
    let errorsList = this.modal.data.content.$messages;
    let exception = this.modal.data.content.$exception;
    if (errorsList) {
      await this.setArgs(errorsList);
      
      this.messageList = errorsList.map((error) => {
        return ({
        tmp:this.$t(error.label.resourceKey ?? error.label.id),

        message: this.$t(
          error.label.resourceKey ?? error.label.id,

          Object.entries(error.label.args).reduce(
            (acc, [key, value]) => ({
              ...acc,
               [key]: typeof value === "number" ? (value === 0 ? "0" : value) : this.$t(value),
            }),
            error.label.args
          )
        ),
        
        
        // 
        level: error.level,
      })}
    );
    } 
    if (exception?.label && exception.label.resourceKey != 'ExitValidationFailed' && exception.label.resourceKey != 'EntryValidationFailed') {
      for (let arg in exception.label.args) {
        exception.label.args[arg] = this.$t(exception.label.args[arg]);
      }
      let exp = {
        message: this.$t(
          exception.label.resourceKey ? this.$t(exception.label.resourceKey, exception.label.args) :
            this.$t(exception.label.id, exception.label.args)
        ),
        level: "Critical",
      };
      this.messageList = [...this.messageList, exp];
    }else if (errorsList === undefined && exception === undefined) {
      if (this.modal.data.content.includes("br")) {
        this.newMessage = this.modal.data.content.split("br")
      }
    }else if(exception.message){
      this.messageList.push(
        {
        message: JSON.stringify(exception.message) ,
        level: "Critical",
      }
      );
    }
  },
  methods: {
    errorType(type) {
      switch (type) {
        case "Critical":
          return "error";
        case "Warning":
          return "warning";
        case "Success":
          return "success";
        case "Information":
          return "info";
        default:
          return "";
      }
    },
    async setArgs(errorsList){
      for(const key in errorsList){
        const item = errorsList[key];
        for(const argKey in item.label.args){
          const arg = item.label.args[argKey];
          item.label.args[argKey] = await this.labelText(arg);
        }
      }
    },
    async labelText(DefID){
      let Result
      const idRegex = /^[a-zA-Z0-9_\.]+$/
      Result = DefID
      console.log('DefID :>> ', DefID);
      if(isNaN(Number(DefID)) && idRegex.test(DefID)){
        const Def = await fetchDefData(DefID, {
          resources: false,
          routes: false,
        });
        Result =  this.$t(Def);
      }
      return Result;
    }
  },
};
</script>
<style>
.modal {
  height: 360px !important;

}
.multi-line {
  white-space: pre-line;
}
.show-message {  
  max-width: 545px;
  overflow-x: auto;  
}
</style>
